import React, { createContext, useContext, useState } from 'react';

const LandingPageContext = createContext();

export const useLandingPageCleanup = () => {
  const context = useContext(LandingPageContext);
  if (!context) {
    return { isCleaningUp: false, cleanupComplete: true };
  }
  return context;
};

export const LandingPageProvider = ({ children }) => {
  const [isCleaningUp, setIsCleaningUp] = useState(false);
  const [cleanupComplete, setCleanupComplete] = useState(true);

  const startCleanup = () => {
    setIsCleaningUp(true);
    setCleanupComplete(false);
  };

  const finishCleanup = () => {
    setIsCleaningUp(false);
    setCleanupComplete(true);
  };

  return (
    <LandingPageContext.Provider value={{ isCleaningUp, cleanupComplete, startCleanup, finishCleanup }}>
      {children}
    </LandingPageContext.Provider>
  );
};

